import T from 'utils/T';
import ex from 'utils/ex';
import React from 'react';
import './VBox.css';
export default React.forwardRef(function VBox(props, ref) {
  const {
    full,
    between,
    stretch,
    center,
    start,
    end,
    vstart,
    vcenter,
    vend,
    vstretch,
    ...rest
  } = props || {};
  return (
    <div {...ex(['VBox', { full, between, stretch, center, start, end, vstart, vcenter, vend, vstretch }], rest)} {...{ ref }}>
    </div>
  );
});